
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M1.5 6.75h14m-14 3.5h14m-14-5.922c0-.457.38-.828.848-.828h12.304c.468 0 .848.37.848.828v8.344c0 .457-.38.828-.848.828H2.348a.84.84 0 0 1-.848-.828zM6.167 3.528v9.939m4.666-9.913v9.85"}})])
          )
        }
      }
    